import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=48628b5d&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=48628b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48628b5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48628b5d')) {
      api.createRecord('48628b5d', component.options)
    } else {
      api.reload('48628b5d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=48628b5d&scoped=true&", function () {
      api.rerender('48628b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/customer/customerApplication/edit.vue"
export default component.exports